// extracted by mini-css-extract-plugin
module.exports = {"root":"TableFilterLabel_root__3njfk","filterIcon":"TableFilterLabel_filterIcon__B2EsS","active":"TableFilterLabel_active__3Np68"};